(function () {
  var SVG_STOCK_CHECK =
    '<svg class="light-function-table__stock-svg" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="10" cy="11" r="10" fill="#C65001" /><path d="M7.74219 14.8594C8.22135 13.7656 8.73438 12.7214 9.28125 11.7266C9.83333 10.7266 10.401 9.80469 10.9844 8.96094C11.6719 7.97135 12.2135 7.25781 12.6094 6.82031C12.8646 6.53906 13.1042 6.30729 13.3281 6.125C13.4583 6.02083 13.6641 5.94271 13.9453 5.89062C14.6276 5.76562 15.1042 5.70312 15.375 5.70312C15.4948 5.70312 15.5547 5.74479 15.5547 5.82812C15.5547 5.90625 15.4948 6 15.375 6.10938C14.3333 7.03646 13.2396 8.36198 12.0938 10.0859C10.9531 11.8099 9.98958 13.6406 9.20312 15.5781C8.90625 16.3021 8.69792 16.7474 8.57812 16.9141C8.46354 17.0755 8.09896 17.1562 7.48438 17.1562C7.08333 17.1562 6.83073 17.1172 6.72656 17.0391C6.6276 16.9609 6.44531 16.7135 6.17969 16.2969C5.72135 15.6042 5.22917 14.9792 4.70312 14.4219C4.42708 14.1302 4.28906 13.9062 4.28906 13.75C4.28906 13.5312 4.44271 13.3177 4.75 13.1094C5.05729 12.8958 5.3099 12.7891 5.50781 12.7891C5.78385 12.7891 6.11458 12.9453 6.5 13.2578C6.89062 13.5651 7.30469 14.099 7.74219 14.8594Z" fill="white" /></svg>';

  var SVG_STOCK_X =
    '<svg class="light-function-table__stock-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#B1B1B1" /><path d="M6.68555 8.2832L6.00342 5.51172C5.97477 5.4222 5.96045 5.34163 5.96045 5.27002C5.96045 5.05518 6.02132 4.87256 6.14307 4.72217C6.26481 4.57178 6.40088 4.49658 6.55127 4.49658C6.8234 4.49658 7.10807 4.68636 7.40527 5.06592C7.70247 5.44189 7.97461 5.94499 8.22168 6.5752C8.28971 6.52148 8.58691 6.20638 9.11328 5.62988C9.54655 5.15723 9.82943 4.87077 9.96191 4.77051C10.098 4.67025 10.2412 4.62012 10.3916 4.62012C10.5778 4.62012 10.7497 4.71143 10.9072 4.89404C11.0684 5.07308 11.1489 5.25928 11.1489 5.45264C11.1489 5.62809 11.054 5.72119 10.8643 5.73193C10.7998 5.73193 10.7586 5.7391 10.7407 5.75342L10.7139 5.85547C10.7031 5.8877 10.6655 5.94499 10.6011 6.02734C10.4006 6.24935 10.1069 6.6665 9.72021 7.27881C9.28695 7.9484 9.04167 8.31543 8.98438 8.37988C8.89486 8.49089 8.8501 8.60547 8.8501 8.72363C8.8501 8.9707 8.92887 9.30729 9.08643 9.7334C9.24756 10.1595 9.46598 10.5659 9.7417 10.9526C9.85986 11.1317 9.91895 11.2498 9.91895 11.3071C9.91895 11.3429 9.88851 11.4092 9.82764 11.5059C9.8527 11.5381 9.86523 11.5703 9.86523 11.6025C9.86523 11.6706 9.84375 11.7207 9.80078 11.7529C9.75781 11.7852 9.65755 11.8424 9.5 11.9248C9.5 12.1361 9.41227 12.2417 9.23682 12.2417C9.16162 12.2417 9.05599 12.1969 8.91992 12.1074C8.78385 12.0179 8.69076 11.9338 8.64062 11.855C8.58691 11.7905 8.5332 11.7476 8.47949 11.7261C8.4222 11.7118 8.37923 11.6938 8.35059 11.6724C8.32194 11.6473 8.25391 11.5775 8.14648 11.4629C8.13932 11.4486 8.09635 11.4181 8.01758 11.3716C7.91732 11.3286 7.82064 11.2158 7.72754 11.0332C7.68099 10.9186 7.55745 10.7056 7.35693 10.394C6.18604 11.658 5.56836 12.3241 5.50391 12.3921C5.43945 12.4637 5.36247 12.5389 5.27295 12.6177C5.18343 12.6965 5.11182 12.7358 5.05811 12.7358C4.99723 12.7358 4.9471 12.7179 4.90771 12.6821C4.87191 12.6463 4.85221 12.5282 4.84863 12.3276L4.77881 12.2524C4.75732 12.231 4.73584 12.1755 4.71436 12.0859L4.60693 12.0322C4.54964 11.9248 4.45296 11.812 4.31689 11.6938L4.30615 11.5273L4.27393 11.3823C4.27393 11.3394 4.29541 11.2695 4.33838 11.1729C4.38493 11.0762 4.60872 10.7861 5.00977 10.3027C5.41081 9.81576 5.65788 9.52751 5.75098 9.43799C6.10189 9.10856 6.28809 8.89193 6.30957 8.78809C6.38477 8.50521 6.51009 8.33691 6.68555 8.2832Z" fill="white" /></svg>';

  function norm(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeRunning(storeValue) {
    var n = norm(storeValue);
    if (!n) return '';
    if (n.includes('not') && n.includes('equip')) return 'not equipped';
    if (n === 'white' || n === 'amber') return n;
    return n;
  }

  function normalizeTurn(storeValue) {
    var n = norm(storeValue);
    if (!n) return '';
    if (n.includes('standard')) return 'standard flashing';
    if (n.includes('sequential')) return 'sequential';
    return n;
  }

  function toArray(value) {
    if (Array.isArray(value)) return value;
    if (value == null) return [];
    if (typeof value === 'string') {
      return value
        .split(/[,\u2022|]/)
        .map(function (item) {
          return item.trim();
        })
        .filter(Boolean);
    }
    return [value];
  }

  function optionText(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'object') {
      if (typeof value.value === 'string') return value.value.trim();
      if (typeof value.label === 'string') return value.label.trim();
      if (typeof value.name === 'string') return value.name.trim();
    }
    return String(value).trim();
  }

  function uniqueNormalized(values, normalizer) {
    var out = [];
    var seen = {};
    values.forEach(function (value) {
      var text = optionText(value);
      var key = normalizer ? normalizer(text) : norm(text);
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push({ text: text, key: key });
    });
    return out;
  }

  function renderPills(container, values, selectorAttr, activeKey) {
    if (!container) return;
    container.innerHTML = '';
    values.forEach(function (option) {
      if (!option || !option.text) return;
      var isActive = option.key === activeKey;
      var pill = document.createElement('span');
      pill.className = 'light-function-table__pill ' + (isActive ? 'is-active' : 'is-inactive');
      pill.setAttribute(selectorAttr, '');
      pill.setAttribute('data-value', option.key);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      pill.innerHTML =
        '<span class="light-function-table__pill-icon" aria-hidden="true">' +
        (isActive ? SVG_STOCK_CHECK : SVG_STOCK_X) +
        '</span>' +
        '<span class="light-function-table__pill-text">' +
        option.text.toUpperCase() +
        '</span>';
      container.appendChild(pill);
    });
  }

  function getLightOptionPosition(root) {
    var p = parseInt(root.getAttribute('data-option-position'), 10);
    return p > 0 ? p : 2;
  }

  function getOptionValueForPosition(productVariants, position) {
    var row = productVariants.querySelector(
      '.product-form__option-selector[data-option-index="' + position + '"]'
    );
    if (!row) return null;
    var sel = row.querySelector('select[name="option' + position + '"]');
    if (sel && sel.value) return sel.value;
    var inp = row.querySelector('input[name="option' + position + '"]:checked');
    return inp ? inp.value : null;
  }

  function getFormForTable(root) {
    var pv = root.closest('product-variants');
    if (!pv) return null;
    var fid = pv.getAttribute('form-id');
    return fid ? document.getElementById(fid) : null;
  }

  function readSelectedVariantId(form) {
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    if (!input || !input.value) return null;
    return input.value;
  }

  function getVariantOptionAt(variant, indexZero) {
    if (!variant) return null;
    if (Array.isArray(variant.options) && variant.options[indexZero] != null) {
      return variant.options[indexZero];
    }
    if (indexZero === 0) return variant.option1;
    if (indexZero === 1) return variant.option2;
    if (indexZero === 2) return variant.option3;
    return null;
  }

  /**
   * Table metaobject is keyed by variant id, but content is determined only by the Forward Light
   * Function option (data-option-position). Pick any variant whose option at that index matches DOM.
   */
  function findVariantIdForLightOption(productVariants, variants, lightPos) {
    if (!variants || !variants.length) return null;
    var o = getOptionValueForPosition(productVariants, lightPos);
    if (!o) return null;
    var idx = lightPos - 1;
    var candidates = variants.filter(function (v) {
      return getVariantOptionAt(v, idx) === o;
    });
    var preferred = candidates.find(function (v) {
      return v.available;
    });
    if (preferred) return String(preferred.id);
    if (candidates.length) return String(candidates[0].id);
    return null;
  }

  /**
   * Never trust form [name=id] alone: ProductVariants debounces updates ~500ms, so id is stale
   * until then. Always derive from the light-function DOM value first (or variant event when it matches).
   */
  function resolveTableVariantId(variantFromEvent, root, productVariants, form) {
    var lightPos = getLightOptionPosition(root);
    var variants = window.theme && window.theme.product && window.theme.product.variants;
    var oLight = getOptionValueForPosition(productVariants, lightPos);
    if (!oLight || !variants) {
      return readSelectedVariantId(form);
    }

    var idx = lightPos - 1;
    if (variantFromEvent && variantFromEvent.id != null) {
      if (getVariantOptionAt(variantFromEvent, idx) === oLight) {
        return String(variantFromEvent.id);
      }
    }

    var fromDom = findVariantIdForLightOption(productVariants, variants, lightPos);
    if (fromDom) return fromDom;

    return readSelectedVariantId(form);
  }

  function clearTableBody(root) {
    var descEl = root.querySelector('[data-light-function-description]');
    if (descEl) descEl.textContent = '';
    var runPills = root.querySelector('[data-light-running-pills]');
    var turnPills = root.querySelector('[data-light-turn-pills]');
    if (runPills) runPills.innerHTML = '';
    if (turnPills) turnPills.innerHTML = '';
  }

  function updateTable(root, variantId, dataMap) {
    var descEl = root.querySelector('[data-light-function-description]');
    var runPills = root.querySelector('[data-light-running-pills]');
    var turnPills = root.querySelector('[data-light-turn-pills]');

    if (!variantId) {
      clearTableBody(root);
      return;
    }

    var data = dataMap[String(variantId)];
    if (!data) {
      clearTableBody(root);
      return;
    }

    var run = normalizeRunning(data.running);
    var turn = normalizeTurn(data.turn);
    var runningOptions = uniqueNormalized(toArray(data.runningOptions), normalizeRunning);
    var turnOptions = uniqueNormalized(toArray(data.turnOptions), normalizeTurn);
    if (!runningOptions.length && run) runningOptions = [{ text: run, key: run }];
    if (!turnOptions.length && turn) turnOptions = [{ text: turn, key: turn }];

    if (descEl) descEl.textContent = (data.description || '').toString();
    renderPills(runPills, runningOptions, 'data-light-running', run);
    renderPills(turnPills, turnOptions, 'data-light-turn', turn);
  }

  function updateRevealState(root, productVariants, form, variantId) {
    var lightPos = getLightOptionPosition(root);
    var hasLight = !!getOptionValueForPosition(productVariants, lightPos);
    var reveal = hasLight && !!variantId;
    root.classList.toggle('light-function-table--concealed', !reveal);
    if (reveal) root.removeAttribute('hidden');
    else root.setAttribute('hidden', '');
  }

  function initRoot(root) {
    var script = root.querySelector('.js-light-function-table-data');
    if (!script) return;

    var dataMap = {};
    try {
      dataMap = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var productVariants = root.closest('product-variants');
    if (!productVariants) return;

    var form = getFormForTable(root);
    var lightPos = getLightOptionPosition(root);
    var lightRowSelector = '.product-form__option-selector[data-option-index="' + lightPos + '"]';

    var sync = function (variantFromEvent) {
      var vid = resolveTableVariantId(variantFromEvent, root, productVariants, form);
      var hasLight = !!getOptionValueForPosition(productVariants, lightPos);
      if (hasLight && vid) {
        updateTable(root, vid, dataMap);
      } else {
        clearTableBody(root);
      }
      updateRevealState(root, productVariants, form, vid);
    };

    var onInteract = function () {
      root.setAttribute('data-user-configured', 'true');
      sync(null);
    };

    productVariants.addEventListener('change', onInteract, true);

    productVariants.addEventListener(
      'click',
      function (ev) {
        if (!ev.target.closest(lightRowSelector)) return;
        root.setAttribute('data-user-configured', 'true');
        window.requestAnimationFrame(function () {
          sync(null);
        });
      },
      true
    );

    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant ? e.detail.variant : null;
      sync(v);
    });

    sync(null);
  }

  function init() {
    document.querySelectorAll('.js-light-function-table').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
